import { useState } from 'react';
import { Modal, Button, Form, Input, Message } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import intranetServiceInstance from 'src/services/api/intranetService';

const UserCreateModal = ({ open, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    status: ['staff'],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setError('');
  };

  const validateForm = () => {
    if (!formData.name || !formData.name.trim()) {
      setError('El nombre es requerido');
      return false;
    }

    if (!formData.email || !formData.email.trim()) {
      setError('El email es requerido');
      return false;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError('El email no es válido');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await intranetServiceInstance.createUser({
        name: formData.name.trim(),
        email: formData.email.trim(),
        password: formData.password,
        status: formData.status,
      });

      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Usuario creado',
          text: 'El usuario ha sido creado correctamente.',
          timer: 2000,
          showConfirmButton: false,
        });
        // Reset form
        setFormData({
          name: '',
          email: '',
          password: '',
          confirmPassword: '',
          status: ['staff'],
        });
        onSuccess();
      } else {
        throw new Error(response.data.message || 'Error al crear el usuario');
      }
    } catch (error) {
      console.error('Error creating user:', error);
      setError(error.response?.data?.message || error.message || 'No se pudo crear el usuario.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
      status: ['staff'],
    });
    setError('');
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} size="small">
      <Modal.Header>Crear Nuevo Usuario</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>Nombre</label>
            <Input
              value={formData.name}
              onChange={(e) => handleChange('name', e.target.value)}
              placeholder="Ingresa el nombre completo"
              error={!!error && !formData.name}
            />
          </Form.Field>
          <Form.Field>
            <label>Email</label>
            <Input
              type="email"
              value={formData.email}
              onChange={(e) => handleChange('email', e.target.value)}
              placeholder="Ingresa el email"
              error={!!error && !formData.email}
            />
          </Form.Field>
          {error && <Message negative>{error}</Message>}
        </Form>
        <p>Se le enviará un email al usuario solicitandole cambiar su contraseña.</p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button primary onClick={handleSubmit} loading={loading}>
          Crear Usuario
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default UserCreateModal;
